export function highlightSearchMatches(value: String, query?: String) {
  return value.replace(new RegExp(`(${query})`, 'gi'), '<b>$1</b>');
}